module.exports = __webpack_public_path__ + "static/media/logo_scudo.fee71b10.png";